import React from "react";
import { SelectInput } from "react-admin";
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    InputAdornment,
    IconButton
} from "@mui/material";

import Clear from "@mui/icons-material/Clear";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { translate } from '../../i18n/customI18nProvider';

const ColorIconRender = ({ record }) => {
    if (!record) return null;

    return (
        <div style={{ display: "flex", alignItems: "center" }}>
            <FiberManualRecordIcon
                style={{
                    color: record.colorCode,
                    height: 18,
                    margin: 0,
                    padding: 0,
                }}
            />
            <span style={{ marginLeft: 3 }}>
                {translate("custom.colors." + record.id)}
            </span>
        </div>
    );
};

class ColorSelectInput extends React.Component {
    // React admin select
    render() {
        return (
            <SelectInput
                {...this.props}
                optionText={<ColorIconRender />}
            />
        );
    }
}

class ColorSelect extends React.Component {

    handleClear = (e) => {
        e.stopPropagation();
        this.props.onChange('');
    };

    handleChange = (e) => {
        this.props.onChange(e.target.value);
    };

    render() {
        const { value, colors, label } = this.props;

        return (
            <FormControl fullWidth variant="standard">
                <InputLabel>{label}</InputLabel>

                <Select
                    value={value}
                    onChange={this.handleChange}
                    endAdornment={
                        value && (
                            <InputAdornment position="end">
                                <IconButton
                                    size="small"
                                    sx={{ mr: 2 }}
                                    onClick={this.handleClear}
                                >
                                    <Clear fontSize="small" />
                                </IconButton>
                            </InputAdornment>
                        )
                    }
                >
                    {colors.map(color => (
                        <MenuItem key={color.id} value={color.id}>
                            <ColorIconRender record={color} />
                        </MenuItem>
                    ))}
                </Select>

            </FormControl>
        );
    }
}

export { ColorSelect, ColorSelectInput };